import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { StateBuildingGraphics } from "../StateBuildingGraphics";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
import { BF2MarketTruck } from "./BF2MarketTruck";
var Container = PIXI.Container;
var truck = new BF2MarketTruck();
export var BF2GetOutskirtBuildingMarket = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Market" + level];
    var container = new Container();
    var graphics = BF2GetConfigBasedOutskirtBuilding(config, false, 1);
    graphics.position.set(30, 0);
    truck.updateState(buildingState || StateBuildingGraphics.Idle);
    truck.position.set(220, 190);
    container.addChild(graphics, truck);
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingMarket.ts
// module id = 2165
// module chunks = 3